import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
var StyledCircle = styled("div")(function (_a) {
    var colors = _a.colors;
    return ({
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: colors ? colors === null || colors === void 0 ? void 0 : colors.backgroundColor : "var(--maintain-light)",
        border: colors
            ? "1px solid ".concat(colors === null || colors === void 0 ? void 0 : colors.borderColor)
            : "1px solid var(--green-color-50)",
    });
});
var CircleComponent = function (_a) {
    var colors = _a.colors;
    return _jsx(StyledCircle, { colors: colors });
};
export default CircleComponent;
